'use strict';

export default function Switch({title, count = undefined, disabled = false, checked = false, onChange}) {

    const inputId = React.useId()

    const handleChange = (value) => {
        onChange && onChange(value)
    }

    return <div className="el__filter">
        <div className="el__filter-content">
            <div className={cn("checkbox4", disabled && "disabled")}>
                <input id={inputId}
                       type="checkbox"
                       checked={checked}
                       disabled={disabled}
                       onChange={(event) => handleChange(event.target.checked)}
                />
                <label htmlFor={inputId}>
                    <span>{title} {count !== undefined && <span style={{fontWeight:'normal'}}>{`(${count})`}</span>}</span>
                    <span className="checkbox-switcher"></span>
                </label>
            </div>
        </div>
    </div>
}